import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';
import { initSentry } from './sentry-init';
import { initPostHog } from './posthog-init';
import { consumeAccessTokenFromUrl } from './access-token-url';

// Must run first: both SDKs record the page URL as soon as they start.
consumeAccessTokenFromUrl();
initSentry();
initPostHog();

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
